module.exports = __webpack_public_path__ + "static/media/clock_w.76b5e5d5.svg";